var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4506 8.26109C2.35018 8.16149 2.27048 8.04299 2.21609 7.91244C2.1617 7.78188 2.13369 7.64185 2.13369 7.50042C2.13369 7.35898 2.1617 7.21895 2.21609 7.08839C2.27048 6.95784 2.35018 6.83934 2.4506 6.73975L7.36817 1.83289C7.46859 1.73329 7.5483 1.61479 7.60269 1.48424C7.65708 1.35368 7.68508 1.21365 7.68508 1.07222C7.68508 0.930783 7.65708 0.790749 7.60269 0.660193C7.5483 0.529637 7.46859 0.411143 7.36817 0.311545C7.16744 0.112002 6.8959 0 6.61286 0C6.32982 0 6.05828 0.112002 5.85755 0.311545L0.939974 5.22912C0.338078 5.83176 0 6.64868 0 7.50042C0 8.35216 0.338078 9.16907 0.939974 9.77171L5.85755 14.6893C6.0571 14.8872 6.32644 14.9988 6.6075 15C6.7485 15.0008 6.88828 14.9738 7.01881 14.9205C7.14934 14.8671 7.26807 14.7886 7.36817 14.6893C7.46859 14.5897 7.5483 14.4712 7.60269 14.3406C7.65708 14.2101 7.68508 14.07 7.68508 13.9286C7.68508 13.7872 7.65708 13.6471 7.60269 13.5166C7.5483 13.386 7.46859 13.2675 7.36817 13.1679L2.4506 8.26109Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.5e9786d53e93a16ffaa5b0f78df4ccb9.svg";
export { ForwardRef as ReactComponent };